import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AceleracaoPage from "../pages/aceleracao/page";
import AceleraPage from "../pages/acelera/page";
import CadastroClientes from "../pages/cadastro-clientes/page";
import VisionPage from "../pages/vision/page";
import LoginPage from "../pages/vision/login/page";
import DashboardPage from "../pages/vision/dashboard/page";
import ClientesPage from "../pages/vision/clientes/page";
import DashboardRecebiveis from "../pages/vision/recebiveis/page";
import RelatoriosPage from "../pages/vision/relatorios/page";
import PlanosPage from "../pages/vision/planos/page";
import PropostasPage from "../pages/vision/propostas/page";
import ServicosPage from "../pages/vision/servicos/page";
import ContratosPage from "../pages/vision/contratos/page";
import UsuariosPage from "../pages/vision/usuarios/page";
import PerfisPage from "../pages/vision/perfis/page";
import IndicadoresPage from "../pages/vision/kpis/indicadores/page";
import ConfiguracaoKPIsPage from "../pages/vision/kpis/configuracao/page";
import OrdenacaoIndicadoresPage from "../pages/vision/kpis/ordenacao/page";
import PlanejamentoPage from "../pages/vision/kpis/planejamento/page";
import ResultadosPage from "../pages/vision/kpis/resultados/page";
import DashboardKPIsPage from "../pages/vision/kpis/dashboard/page";
import IndicadoresCalculadosPage from "../pages/vision/kpis/indicadores-calculados/page";
import PrevisibilidadeIAPage from "../pages/vision/kpis/previsibilidade/page";
import SegmentosPage from "../pages/vision/configuracoes/segmentos/page";
import InteligenciaMercadoPage from "../pages/vision/inteligencia-mercado/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aceleracao",
    element: <AceleracaoPage />,
  },
  {
    path: "/acelera",
    element: <AceleraPage />,
  },
  {
    path: "/cadastro-clientes",
    element: <CadastroClientes />,
  },
  {
    path: "/vision",
    element: <VisionPage />,
  },
  {
    path: "/vision/login",
    element: <LoginPage />,
  },
  {
    path: "/vision/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/vision/clientes",
    element: <ClientesPage />,
  },
  {
    path: "/vision/servicos",
    element: <ServicosPage />,
  },
  {
    path: "/vision/planos",
    element: <PlanosPage />,
  },
  {
    path: "/vision/propostas",
    element: <PropostasPage />,
  },
  {
    path: "/vision/contratos",
    element: <ContratosPage />,
  },
  {
    path: "/vision/recebiveis",
    element: <DashboardRecebiveis />,
  },
  {
    path: "/vision/relatorios",
    element: <RelatoriosPage />,
  },
  {
    path: "/vision/usuarios",
    element: <UsuariosPage />,
  },
  {
    path: "/vision/perfis",
    element: <PerfisPage />,
  },
  {
    path: "/vision/kpis/indicadores",
    element: <IndicadoresPage />,
  },
  {
    path: "/vision/kpis/configuracao",
    element: <ConfiguracaoKPIsPage />,
  },
  {
    path: "/vision/kpis/ordenacao",
    element: <OrdenacaoIndicadoresPage />,
  },
  {
    path: "/vision/kpis/planejamento",
    element: <PlanejamentoPage />,
  },
  {
    path: "/vision/kpis/resultados",
    element: <ResultadosPage />,
  },
  {
    path: "/vision/kpis/dashboard",
    element: <DashboardKPIsPage />,
  },
  {
    path: "/vision/kpis/indicadores-calculados",
    element: <IndicadoresCalculadosPage />,
  },
  {
    path: "/vision/kpis/previsibilidade",
    element: <PrevisibilidadeIAPage />,
  },
  {
    path: "/vision/configuracoes/segmentos",
    element: <SegmentosPage />,
  },
  {
    path: "/vision/inteligencia-mercado",
    element: <InteligenciaMercadoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
